import { RootState } from '../../config';
import { IOrganizationDevice, IOrganizationUser } from '../../interfaces';
import {
  IOrganizationDevicesSort,
  IOrganizationFilters,
  IOrganizationState,
  IOrganizationUsersRoleFilter,
  IOrganizationUsersSort,
} from './types';

export const selectOrganization = (state: RootState): IOrganizationState => state.organization;
export const selectOrganizationDevices = (state: RootState): IOrganizationDevice[] => state.organization.devices;
export const selectOrganizationUsers = (state: RootState): IOrganizationUser[] => state.organization.users;
export const selectOrganizationFilters = (state: RootState): IOrganizationFilters => state.organization.filters;
export const selectOrganizationDevicesSearchText = (state: RootState): string => state.organization.searchText.devices;
export const selectOrganizationDevicesSort = (state: RootState): IOrganizationDevicesSort =>
  state.organization.sort.devices;
export const selectOrganizationUsersSearchText = (state: RootState): string => state.organization.searchText.users;
export const selectOrganizationUsersRoleFilter = (state: RootState): IOrganizationUsersRoleFilter =>
  state.organization.filters.role;
export const selectOrganizationUsersSort = (state: RootState): IOrganizationUsersSort => state.organization.sort.users;
